import moment from "moment-timezone";

export const convertUTCTimeToUserTimezone = (
  dateString,
  timeString,
  targetTimezone,
) => {
  try {
    const interviewDate = moment.utc(dateString).format("YYYY-MM-DD");
    const utcTime = moment.utc(timeString).format("HH:mm:ss");
    const combinedUTC = moment.utc(`${interviewDate}T${utcTime}`);
    let tz = targetTimezone;
    if (!tz || !moment.tz.zone(tz)) {
      console.warn(`Invalid timezone: ${tz}, falling back to UTC`);
      tz = "UTC";
    }
    const convertedTime = combinedUTC.tz(tz);
    return convertedTime.toDate();
  } catch (error) {
    console.error("Error converting timezone:", error);
    return moment.utc(timeString).toDate();
  }
};

export const getTimezone = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) return timezone;
  } catch (error) {
    console.error("Intl API not available, falling back to moment");
  }
  try {
    if (typeof moment !== "undefined" && moment.tz) {
      return moment.tz.guess();
    }
  } catch (error) {
    console.error("Moment not available:", error);
  }
  return "UTC";
};
